<template>
  <div>
    <myHeader></myHeader>

    <div class="webVideo">
      <video autoplay muted loop>
        <source src="../../assets/VideoSite01.mp4" type="video/mp4" alt="video d'accueil de Privilégia Coiffure">
      </video>
    </div>
    <br>
    <div class="webHomeContacts">
      <div class="webHomeContactsIntermediary">
        <img class="webHeaderLogos" src="../../assets/Icon-Location.svg" alt="logo localisation">
        <p class="webHomeContactsIntermediaryFont1">20 km autour de Golbey (88)</p>
      </div>

      <div class="webHomeContactsIntermediary">
        <a href="tel:+33680599130"><img class="webHeaderLogos" src="../../assets/Icon-Phone.svg" alt="logo telephone">
          <p class="webHomeContactsIntermediaryFont1">06 80 59 91 30</p>
        </a>
      </div>

      <div class="webHomeContactsIntermediary">
        <img class="webHeaderLogos" src="../../assets/Icon-Calendar.svg" alt="logo calendrier">
        <li class="webHomeContactsIntermediaryFont2">Lundi : 9h00 - 19h00</li>
        <li class="webHomeContactsIntermediaryFont2">Mercredi : 14h00 - 19h00</li>
        <li class="webHomeContactsIntermediaryFont2">Vendredi : 9h00 - 19h00</li>
        <li class="webHomeContactsIntermediaryFont2">Samedi : Mariages / évènements</li>
      </div>
    </div>

    <br>

    <div class="webHomeContacts">
      <div class="webHomeContactsIntermediary webHomeFlex1">
        <a href="https://www.facebook.com/Gmsoniapro"><img class="webHeaderLogos" src="../../assets/Icon-Facebook.svg"
            alt="logo facebook">
          <p class="webHomeContactsIntermediaryFont1">Facebook</p>
        </a>
      </div>
      <div class="webHomeContactsIntermediary webHomeFlex1">
        <a href="https://www.facebook.com/messages/t/Gmsoniapro"><img class="webHeaderLogos"
            src="../../assets/Icon-Messenger.svg" alt="logo messenger">
          <p class="webHomeContactsIntermediaryFont1">Messenger</p>
        </a>
      </div>
      <div class="webHomeContactsIntermediary webHomeFlex1">
        <a href="https://www.instagram.com/privilegia_coiffure"><img class="webHeaderLogos"
            src="../../assets/Icon-Instagram.svg" alt="logo instagram">
          <p class="webHomeContactsIntermediaryFont1">Instagram</p>
        </a>
      </div>
      <div class="webHomeContactsIntermediary webHomeFlex1">
        <a href="https://www.tiktok.com/@soniagms"><img class="webHeaderLogos"
            src="../../assets/Icon-Tiktok.svg" alt="logo tik tok">
          <p class="webHomeContactsIntermediaryFont1">Tik tok</p>
        </a>
      </div>
      <div class="webHomeContactsIntermediary webHomeFlex1">
        <a href="mailto:privilegiacoiffure@gmail.com"><img class="webHeaderLogos" src="../../assets/Icon-Mail.svg"
            alt="logo mail">
          <p class="webHomeContactsIntermediaryFont1">Email</p>
        </a>
      </div>
    </div>

    <br>

    <div class="webHomeContacts">
      <div class="webHomeContactsIntermediaryFont1">Femmes
        <br>
        <img @click.prevent="goFemmes()" class="webHomePrestationsPicture appHoverEffect"
          src="../../assets/PrestationFemme.jpg" alt="Femme avec coiffeur">
      </div>
      <div class="webHomeContactsIntermediaryFont1">Hommes
        <br>
        <img @click.prevent="goHommes()" class="webHomePrestationsPicture appHoverEffect"
          src="../../assets/PrestationHomme.jpg" alt="Homme avec coiffeur">
      </div>
      <div class="webHomeContactsIntermediaryFont1">Enfants
          <br>
          <img @click.prevent="goEnfants()" class="webHomePrestationsPicture appHoverEffect"
          src="../../assets/PrestationEnfant.jpg" alt="Enfant avec coiffeur">
        </div>
        <div class="webHomeContactsIntermediaryFont1">Trichothérapy
          <br>
          <img @click.prevent="goSoins()" class="webHomePrestationsPicture appHoverEffect"
          src="../../assets/PrestationSoin3.jpg" alt="Trichotherapy">
      </div>
    </div>

    <myFooter></myFooter>
  </div>
</template>

<script>
export default {
  name: 'WebHome',
  data () {
    return {
    }
  },
  methods: {
    goFemmes () {
      this.$router.push('/Tarifs/Femmes')
    },
    goHommes () {
      this.$router.push('/Tarifs/Hommes')
    },
    goEnfants () {
      this.$router.push('/Tarifs/Enfants')
    },
    goSoins () {
      this.$router.push('/Tarifs/Soins-Energetiques')
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/SiteWeb/WebHome.vue